import { ReactNode } from "react";
import { createPortal } from "react-dom";

const Printable = ({ children }: { children: ReactNode }) => {
  return createPortal(children, document.getElementById("print") as HTMLElement);
};

export default Printable;
